module.exports = __webpack_public_path__ + "media/images/lb/080-b446df50b08437d981fc8716ff8e98c7.svg";